var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,128.198c35.391,0,64.096-28.697,64.096-64.103C320.095,28.697,291.391,0,256,0 c-35.405,0-64.095,28.697-64.095,64.095C191.905,99.5,220.595,128.198,256,128.198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.733,291.466v-92.64l-68.136,14.462c-15.014-30.456-45.579-45.063-76.45-52.018l-63.732,81.784 l-3.386,0.72l-3.474-0.742l-63.732-81.761c-30.856,6.955-61.407,21.562-76.421,52.018l-68.15-14.462v92.64 c-17.703,2.326-31.379,17.441-31.379,35.79c0,18.342,13.676,33.458,31.379,35.783v104.078l205.265,43.5l6.511,1.381l6.511-1.381 l205.192-43.5V363.04c17.717-2.326,31.394-17.442,31.394-35.783C499.127,308.908,485.45,293.799,467.733,291.466z M249.518,497.328 L57.29,456.589v-94.188c15.958-3.757,27.848-18.052,27.848-35.144c0-17.106-11.889-31.393-27.848-35.144v-77.169l192.228,40.732 V497.328z M454.696,292.113c-15.944,3.75-27.847,18.037-27.847,35.144c0,17.092,11.903,31.387,27.847,35.144v94.188L262.54,497.328 V255.677l192.156-40.732V292.113z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "214.665,274.898 96.081,248.584 96.081,273.96 214.665,300.267 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.755,320.506 97.157,294.185 94.991,304.438 213.589,330.752 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.755,345.882 97.157,319.554 94.991,329.808 213.589,356.129 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.755,385.626 97.157,359.298 94.991,369.551 213.589,395.88 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.755,410.995 97.157,384.666 94.991,394.928 213.589,421.242 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "215.755,436.35 97.157,410.028 94.991,420.282 213.589,446.604 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.535,444.169 97.157,435.391 94.991,445.637 136.369,454.423 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413.724,360.431L295.126,386.76v50.724l118.598-26.314V360.431z M403.231,402.674L305.62,424.54v-29.286 l97.611-21.881V402.674z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "294.05,457.722 296.216,467.969 414.799,441.654 412.634,431.393 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "413.724,261.556 411.559,251.331 293.323,277.579 295.489,287.804 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "413.724,286.844 411.559,276.62 293.323,302.869 295.489,313.079 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "413.724,312.112 411.559,301.895 293.323,328.136 295.489,338.361 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "413.724,337.402 411.559,327.177 293.323,353.44 295.489,363.65 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.509,
    y: 159.127,
    className: "st0",
    width: 28.952,
    height: 14.482
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "241.509,215.838 256,234.413 270.462,215.838 270.462,179.939 241.509,179.939 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.d2f603df263f16d8f8df39a015415878.svg";
export { ForwardRef as ReactComponent };